import '../vendor/oms'

require('es6-promise').polyfill();

const loadGoogleMapsApi = require('load-google-maps-api')

$('.map').each(function () {

  let element = this;
  let locations = $(element).data('locations')
  let selectedCategory = $(element).data('category')
  let categories = $('#location-category-select option')
    .filter(function () {
      return $(this).attr('value') !== '';
    })
    .map(function () {
      return $(this).attr('value');
    })
    .get();

  if (!categories.includes(selectedCategory)) {
    selectedCategory = null;
  }

  $('#location-category-select option').each(function () {
    if ($(this).attr('value') === selectedCategory ) {
      $(this).prop('selected', true);
    }
  });

  function init(googleMaps) {

    let map = new googleMaps.Map(element, {
      zoom: 12,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      styles: [
        {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#444444"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
            {
              "color": "#f2f2f2"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            },
            {
              "lightness": 45
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
            {
              "color": "#46bcec"
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#9fe2ed"
            }
          ]
        }
      ]
    })

    var oms = new OverlappingMarkerSpiderfier(map, {
      basicFormatEvents: true,
      legWeight: 2,
      keepSpiderfied: true
    })

    // need to keep this import within the google maps init function
    const SnazzyInfoWindow = require('snazzy-info-window');

    var currentOpenInfoWindow;

    $.each(locations, function (index, location) {
      let marker = new googleMaps.Marker({
        icon: {
          anchor: new google.maps.Point(7, 25),
          size: new google.maps.Size(14, 25),
          scaledSize: new google.maps.Size(14, 25),
          url: '/assets/images/map-marker.svg'
        },
        optimized: false,
        position: {
          lat: parseFloat(location.latitude),
          lng: parseFloat(location.longitude)
        }
      })

      location.content = $('[data-locationId="' + location.id + '"]').html();

      var infoWindow = new SnazzyInfoWindow({
        marker: marker,
        content: location.content,
        lat: parseFloat(location.latitude),
        lng: parseFloat(location.longitude),
        openOnMarkerClick: false
      });

      google.maps.event.addListener(marker, 'spider_click', function() {
        infoWindow.open();
        if (currentOpenInfoWindow && currentOpenInfoWindow != infoWindow) {
          currentOpenInfoWindow.close();
          currentOpenInfoWindow = null;
        }
        currentOpenInfoWindow = infoWindow;
      });

      location.marker = marker;
    });


    showLocationsForCategory(selectedCategory);
    $('#location-category-select').on('change', function () {
      showLocationsForCategory($(this).val());
    });

    function showLocationsForCategory(category) {
      var selectedLocations = [];
      if (!categories.includes(category)) {
        selectedLocations = locations;
      } else {
        selectedLocations = locations.filter(function (location) {
          return location.categories.includes(category);
        });
      }

      oms.removeAllMarkers();

      selectedLocations.forEach(function (location) {
        oms.addMarker(location.marker);
      });

      fitBoundsToLocations(selectedLocations)
    }

    function fitBoundsToLocations(locations) {
      if (locations.length === 0) {
        return;
      }

      let bounds = new googleMaps.LatLngBounds()

      locations.forEach(function (location) {
        bounds.extend(location.marker.getPosition());
      })

      googleMaps.event.addListenerOnce(map, 'bounds_changed', function(event) {
        // if you have only 1 marker or all markers are on the same address
        // the map will be zoomed too much.
        if (map.getZoom() > 9 ) {
          map.setZoom(9);
        }
      });

      // setTimeout hack to prevent IE Edge from zooming all the way out
      setTimeout(function () {
        map.setCenter(bounds.getCenter())
        map.fitBounds(bounds)
      }, 100);
    }
  }

  loadGoogleMapsApi({
    key: $(this).data('key')
  })
  .then(init);

})



// WEBPACK FOOTER //
// ./public/assets/js/src/components/map.js